import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsm from '../components/shared/InnerTabsm';
import { UserIcon2 } from '../components/shared/Icons';
import CleanersCard from './CleanersCard';


const TABS = [
  {
    id: 'recruitment',
    label: 'Recruitment',
    
  },
  
];

const CLEANER_INNER = [
  { id: 'current', label: 'Current', icon: <UserIcon2 />, component: () => <CleanersCard template="1" /> },
  { id: 'active', label: 'Active', icon: <UserIcon2 />, component: () => <CleanersCard template="2" /> },
  { id: 'notactive', label: 'Not Active', icon: <UserIcon2 />, component: () => <CleanersCard template="3" /> },
];



const FilterSuperRecruitUpdatePagem = () => {
  const [activeTab, setActiveTab] = useState('recruitment');
  const { homeAccent } = useUser();

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'recruitment' && <InnerTabsm tabs={CLEANER_INNER} defaultId="current"/>}
       
      </div>
    </div>
  );
};

export default FilterSuperRecruitUpdatePagem;